import inputData from './inputData/lead-qualification-form';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'lead-qualification-form',
  title: 'Lead Qualification Form',
  description: `Capture new leads and quickly determine whether they're the right fit for your product or service.`,
  image: '/images/templates/lead-qualification-form.png',
  tags: ['lead-generation', 'sales', 'make-sales'],
  inputData: inputData,
  formPreview: convertDraftParamsToLeadForm(inputData(),
    previewInput
  ),
}

export default template;

